import * as React from 'react';
import { SVGProps } from 'react';

export const SvgUpload = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={48}
        height={40}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="m32.499 28-8-8m0 0-8 8m8-8v18m16.78-5.22A10 10 0 0 0 36.499 14h-2.52a15.998 15.998 0 0 0-28.41-5.433 16 16 0 0 0 .93 20.033"
            stroke="#8E94A9"
            strokeWidth={3}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
